import styled from "styled-components";

const ArrowBase = styled.div`
  display: inline-block;
  width: 0;
  height: 0;
  cursor: pointer;
  vertical-align: middle;
`;

export default ArrowBase;
